import { render, staticRenderFns } from "./NewQuery.vue?vue&type=template&id=112aa3b8&scoped=true&"
import script from "./NewQuery.vue?vue&type=script&lang=js&"
export * from "./NewQuery.vue?vue&type=script&lang=js&"
import style0 from "./NewQuery.vue?vue&type=style&index=0&id=112aa3b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112aa3b8",
  null
  
)

export default component.exports